import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
import queue from './queue'
import errors from './errors'
import auth from './auth'
import destiny from './destiny'
import firebase from 'firebase'
import firebaseAuth from './firebase-auth'

function loadFavorities () {
  try {
    return JSON.parse(localStorage.getItem('favorites') || '[]')
  } catch (e) {
    return []
  }
}

const DEFAULT_TAGS_DEFINITIONS = {
  'PvP': {'color': '#b71c1c'},
  'Raid set': {'color': '#1A237E'},
  'Nightfall set': {'color': '#263238'}
}

function loadTagsDefinitions () {
  try {
    return JSON.parse(localStorage.getItem('tagsDefinitions') || 'false') || DEFAULT_TAGS_DEFINITIONS
  } catch (e) {
    return DEFAULT_TAGS_DEFINITIONS
  }
}

function loadTags () {
  try {
    return JSON.parse(localStorage.getItem('tags') || 'false') || {}
  } catch (e) {
    return {}
  }
}

const state = {
  destinyAccounts: null,
  favorites: loadFavorities(),
  tagsDefinitions: loadTagsDefinitions(),
  tags: loadTags()
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    queue,
    errors,
    auth,
    destiny,
    firebaseAuth
  }
})

/* firebase */
/* TODO: cleanup favs */

store.watch(() => store.state.firebaseAuth.user, newUser => {
  if (newUser) {
    if (store.state.firebaseAuth.user) {
      const favoritiesRef = firebase.firestore().collection('favorities').doc(store.state.firebaseAuth.user.uid)
      favoritiesRef.onSnapshot(doc => {
        if (doc.exists) {
          store.commit('setFavorities', doc.data())
        }
      })
      const searchesRef = firebase.firestore().collection('searches').doc(store.state.firebaseAuth.user.uid)
      searchesRef.onSnapshot(doc => {
        if (doc.exists) {
          store.commit('destiny/filters/updateSearches', doc.data())
        }
      })
      const tagsDefinitionsRef = firebase.firestore().collection('tagsDefinitions').doc(store.state.firebaseAuth.user.uid)
      tagsDefinitionsRef.onSnapshot(doc => {
        if (doc.exists) {
          store.commit('updateTagsDefinitions', doc.data())
        }
      })
      const tagsRef = firebase.firestore().collection('tags').doc(store.state.firebaseAuth.user.uid)
      tagsRef.onSnapshot(doc => {
        if (doc.exists) {
          store.commit('updateTags', doc.data())
        }
      })
    }
  }
})

store.watch(() => store.state.favorites, favorities => {
  if (store.state.firebaseAuth.user.uid) {
    const favoritiesRef = firebase.firestore().collection('favorities').doc(store.state.firebaseAuth.user.uid)
    favoritiesRef.set({favorities})
  }
})

store.watch(() => store.state.destiny.filters.searches, searches => {
  if (store.state.firebaseAuth.user.uid) {
    const searchesRef = firebase.firestore().collection('searches').doc(store.state.firebaseAuth.user.uid)
    searchesRef.set({searches})
  }
})

store.watch(() => store.state.tagsDefinitions, tagsDefinitions => {
  if (store.state.firebaseAuth.user.uid) {
    const tagsDefinitionsRef = firebase.firestore().collection('tagsDefinitions').doc(store.state.firebaseAuth.user.uid)
    tagsDefinitionsRef.set({tagsDefinitions})
  }
}, {deep: true})

store.watch(() => store.state.tags, tags => {
  if (store.state.firebaseAuth.user.uid) {
    const tagsRef = firebase.firestore().collection('tags').doc(store.state.firebaseAuth.user.uid)
    tagsRef.set({tags})
  }
}, {deep: true})

store.watch(() => store.state.destiny.filters.search, newSearch => {
  store.dispatch('destiny/filters/computeTokens')
})

if (process.env.NODE_ENV !== 'production') {
  window.store = store
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js